




























































































































import {Vue, Component} from "vue-property-decorator";
import axiosInstance from "../../../../axios";
// @ts-ignore
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/themes/material_blue.css';
import { Russian } from "flatpickr/dist/l10n/ru.js";
import * as dayjs from 'dayjs'
import {Notification} from "../../../../../types/notifications";
import Activity = Notification.Activity;
import {Statistic} from "../../../../../types/statistic";
import {Tool} from "../../../../helpers/Tool";
import DataTable from "datatables.net";

@Component({
    components: {flatPickr},
})

export default class Invites extends Vue {
    private invites: Statistic.Invites|null = null;
    private date: string = '';
    private config: any = {
        locale: Russian,
        dateFormat: 'Y.m.d',
        mode: 'range',
        defaultDate: this.date,
    };
    //@ts-ignore
    private dateFrom: string = dayjs().subtract(30, 'days').format('YYYYMMDD');
    //@ts-ignore
    private dateTo: string = dayjs().format('YYYYMMDD');

    private activeTags: Array<string> = [];
    private ascSorting: boolean = true;
    private searchValue: string = '';
    private tableFilters: any = null;

    mounted(): void {
        this.getTotalInfo();
    }

    /**
     * Сумма по всем тэгам
     * @private
     */
    private get totalInvite(): Statistic.Invite|null
    {
        if (this.invites) {
            return this.invites['total'].total;
        }

        return null;
    }

    /**
     * Отфильтрованные игры
     */
    private get filteredInvites(): Statistic.Invites|null
    {
        if (!this.invites) {
            return null;
        }
        // TODO поиск через запятую
        return Object.keys(this.invites).reduce((invites: Statistic.Invites, invite: string) => {
                if (!this.searchValue.length || invite.toUpperCase().includes(this.searchValue.toUpperCase())) {
                    invites[invite] = (this.invites as Statistic.Invites)[invite];
                }
            return invites;
        }, {});
    }

    private initDatatable(): void
    {
        //@ts-ignore
        /*this.tableFilters = new DataTable('#tags-table', {
            "dom": 't<"tags-statistics__pagination"lip>',
            "ordering": false,
            "language": {
                "lengthMenu": "Rows per page _MENU_",
                "info": "_START_-_END_ of _TOTAL_",
                "paginate": {
                    "next":       "<svg width=\"6\" height=\"10\" viewBox=\"0 0 6 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
                        "<path d=\"M0.200293 1.10636C-0.428118 0.51287 0.566865 -0.426818 1.19528 0.216126L5.80362 4.51891C6.06546 4.7662 6.06546 5.21131 5.80362 5.4586L1.19528 9.81084C0.566865 10.4043 -0.428118 9.46464 0.200293 8.87115L4.28496 5.01348L0.200293 1.10636Z\" fill=\"#6E6893\"/>\n" +
                        "</svg>\n",
                    "previous":   "<svg width=\"6\" height=\"10\" viewBox=\"0 0 6 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
                        "<path d=\"M5.79971 1.10636C6.42812 0.51287 5.43313 -0.426818 4.80472 0.216126L0.196378 4.51891C-0.0654595 4.7662 -0.0654595 5.21131 0.196378 5.4586L4.80472 9.81084C5.43313 10.4043 6.42812 9.46464 5.79971 8.87115L1.71504 5.01348L5.79971 1.10636Z\" fill=\"#6E6893\"/>\n" +
                        "</svg>\n"
                },
            }
        });*/
    }

    private resetDatatable(): void
    {
        /*this.tableFilters.destroy();
        this.$nextTick(() => {
            this.initDatatable();
        });*/
    }

    /**
     * Список игр с контент-паками
     * @private
     */
    private getTotalInfo(): Promise<{[key: number]: Activity}>
    {
        const params = new URLSearchParams();
        if (this.dateFrom) {
            params.append('date_from', this.dateFrom);
        }
        if (this.dateTo) {
            params.append('date_to', this.dateTo);
        }

        return new Promise((resolve, reject) => {
            axiosInstance.get(`/statistics/invites`, {params})
                .then(response => {
                    if (typeof response.data.errors === 'undefined') {
                        this.invites = response.data.response.data;
                        resolve(response.data);

                        if (!this.tableFilters) {
                            this.$nextTick(() => {
                                this.initDatatable();
                            });
                        } else {
                            this.resetDatatable();

                        }
                    } else {
                        reject(response.data);
                    }
                }).catch(error => {
                reject(error);
            });
        });
    }

    /**
     * Получить минуты из секунд
     * @param sec
     * @private
     */
    private getMinutes(sec: number): number
    {
        return Tool.getMinutesFromSeconds(sec);
    }

    /**
     * Получить часы и минуты из секунд
     * @param sec
     * @private
     */
    private getHoursAndMinutesFromSeconds(sec: number): string
    {
        return Tool.getHoursAndMinutesFromSeconds(sec);
    }

    /**
     * Преобразовать из секунд дату в формате строки
     * @param timestamp
     * @private
     */
    private getStringFullDate(timestamp: number): string
    {
        // @ts-ignore
        return dayjs(timestamp * 1000).format('DD.MM.YYYY');
    }

    /**
     * Изменить дату в календаре
     * @param selectedDates
     * @private
     */
    private changeDate(selectedDates: any): void
    {
        // @ts-ignore
        this.dateFrom = typeof selectedDates[0] !== 'undefined' ? dayjs(selectedDates[0]).format('YYYYMMDD') : '';
        // @ts-ignore
        this.dateTo = typeof selectedDates[1] !== 'undefined' ? dayjs(selectedDates[1]).format('YYYYMMDD') : '';

        this.getTotalInfo();
    }

    /**
     * Очистить дату в календаре
     * @private
     */
    private clearDate(): void
    {
        this.dateFrom = '';
        this.dateTo = '';
        this.date = '';

        this.getTotalInfo();
    }

    /**
     * Показать/скрыть таблицу
     * @param name
     * @private
     */
    private toggleTable(name: string): void
    {
        if (this.activeTags.includes(name)) {
            this.activeTags = this.activeTags.filter(tag => tag !== name);
        } else {
            this.activeTags.push(name);
        }
    }

    /**
     * Сортировать по алфавиту
     * @private
     */
    private sortByName(): void
    {
        if (this.ascSorting) {
            if (this.invites) {
                this.invites = Object.keys(this.invites).sort().reduce(
                    (obj, key) => {
                        // @ts-ignore
                        obj[key] = this.invites[key];
                        return obj;
                    },
                    {}
                );
            }
        }
        else {
            if (this.invites) {
                this.invites = Object.keys(this.invites).sort().reverse().reduce(
                    (obj, key) => {
                        // @ts-ignore
                        obj[key] = this.invites[key];
                        return obj;
                    },
                    {}
                );
            }
        }

        this.ascSorting = !this.ascSorting;
        this.resetDatatable();
    }

    /**
     * Сортировать по дате создания
     * @private
     */
    private sortByDate(): void
    {
        if (this.ascSorting) {
            if (this.invites) {
                this.invites = Object.fromEntries(
                    Object.entries(this.invites)
                        .sort(([,a],[,b]) => (a.total.first_timestamp ?? 0) - (b.total.first_timestamp ?? 0))
                );
            }
        }
        else {
            if (this.invites) {
                this.invites = Object.fromEntries(
                    Object.entries(this.invites)
                        .sort(([,a],[,b]) => (b.total.first_timestamp ?? 0) - (a.total.first_timestamp ?? 0))
                );
            }
        }

        this.ascSorting = !this.ascSorting;
        this.resetDatatable();
    }

    /**
     * Сортировать по дате кол-ву инвайтов
     * @private
     */
    private sortByInvitesAmount(): void
    {
        if (this.ascSorting) {
            if (this.invites) {
                this.invites = Object.fromEntries(
                    Object.entries(this.invites)
                        .sort(([,a],[,b]) => Object.keys(a).length - Object.keys(b).length)
                );
            }
        }
        else {
            if (this.invites) {
                this.invites = Object.fromEntries(
                    Object.entries(this.invites)
                        .sort(([,a],[,b]) => Object.keys(b).length - Object.keys(a).length)
                );
            }
        }

        this.ascSorting = !this.ascSorting;
        this.resetDatatable();
    }

    /**
     * Получить подробную информацию по тегу
     * @param name
     * @private
     */
    private getDetailedTag(name: string): void
    {
        this.$emit('get-detailed-tag', name);
    }

    /**
     * Получить подробную информацию по коду
     * @param name
     * @private
     */
    private getDetailedCode(name: string): void
    {
        this.$emit('get-detailed-code', name);
    }
}
